import axios from 'axios';
import { assignOutletIdHeader } from '../utils/selectedOutletId';
import {
  REPORT_TRANSACTION,
  REPORT_TRANSACTION_DETAIL,
  EXPORT_TRANSACTION,
  EXPORT_TRANSACTION_BY_ITEM,
} from './constants';

/** **************************************************************
 * Transaction API
 *************************************************************** */

/**
 * @param {object} query query params
 * @return {Axios.IPromise<U>}
 */
export function getTransactions(query) {
  const headers = { params: query, withCredentials: true };
  const finalHeaders = assignOutletIdHeader(headers);

  return axios.get(REPORT_TRANSACTION, finalHeaders).catch((error) => {
    const { response } = error;
    return Promise.reject(response);
  });
}
/**
 *
 * @param {int} transactionId
 * @param {object} query
 * @return
 */
export function getTransactionDetail(transactionId, query) {
  const headers = { params: query, withCredentials: true };
  const finalHeaders = assignOutletIdHeader(headers);

  return axios
    .get(REPORT_TRANSACTION_DETAIL(transactionId), finalHeaders)
    .catch((error) => {
      const { response } = error;
      return Promise.reject(response);
    });
}

export function exportTransaction(query) {
  const headers = { params: query, withCredentials: true };
  const finalHeaders = assignOutletIdHeader(headers);

  return axios.get(EXPORT_TRANSACTION, finalHeaders).catch((error) => {
    if (error.response) {
      const eobj = new Error(error.response.errors);
      return Promise.reject(eobj);
    }
    return Promise.reject(error);
  });
}

export function exportTransactionByItem(query) {
  const headers = { params: query, withCredentials: true };
  const finalHeaders = assignOutletIdHeader(headers);

  return axios.get(EXPORT_TRANSACTION_BY_ITEM, finalHeaders).catch((error) => {
    if (error.response) {
      const eobj = new Error(error.response.errors);
      return Promise.reject(eobj);
    }
    return Promise.reject(error);
  });
}
